import React, { useState, useEffect, useRef } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

//import './App.css';

// import ASSEC_Helmet from './components/Pagina/ASSEC_Helmet/ASSEC_Helmet_async';

import { usarToken } from './UseToken';
import useToken from './UseToken';

// import Preview from './components/Pagina/Preview/Preview';

import Pagina from './components/Pagina/PaginaCustomer';

import Cookies from "./components/Pagina/Cookies/Cookies";
import GoTopButton from './components/Pagina/GoTopButton/GoTopButton';

import Content from './components/Pagina/Content/Content';

import RegistClient from "./components/Pagina/Cliente/RegisterClient";
import RecoveryClient from "./components/Pagina/Cliente/RecoveryClient";

import ClientList from "./components/Pagina/Cliente/ClientsList";
import NotificationList from "./components/Pagina/Cliente/Notifications";
import PerfilClient from "./components/Pagina/Cliente/Perfil";
import PerfilClient2 from "./components/Pagina/Cliente/ClientPerfil";


import SupportAssistance from "./components/Pagina/Support/Assistance";
import SupportComplaint from "./components/Pagina/Support/Complaint";
import SupportSuggestion from "./components/Pagina/Support/Suggestion";
import SupportProposal from "./components/Pagina/Support/Proposal";

import RelationDocuments from "./components/Pagina/Relation/Documents";
import RelationDownloads from "./components/Pagina/Relation/Downloads";

import Loader from './loader'

import * as Hosts from './Hosts';

import {
  repo_favicon_link,
  reqGET,
  translate,
  content_language,
  set_language
} from './Utils';

function App() {
  
  const { pathname } = useLocation();

  const [, set_dados] = useState(null);
  const is_logged_in = useRef(null);

  const [/* maintenance */, set_maintenance] = useState(false)
  const [template, set_template] = useState({})
  const [theme, set_theme] = useState({})
  const [dados_config, set_dados_config] = useState({})
  // const [dados_navbar, set_dados_navbar] = useState({})

  const [, setRefresh] = useState({})

  const { setToken } = useToken();

  const navbar_data_interface = {
    id: '',
    info: {},
    content: {
        childs: []
    }
  }

  const navbar = useRef(navbar_data_interface);

  const [lang, ] = useState(localStorage.getItem('lang'))
  
  const handleFavIcon = (url) => {
    function getFaviconEl() {
      return document.getElementById("favicon");
    }
    const favicon = getFaviconEl(); // Accessing favicon element
    
    if(url !== undefined && url !== '') {
      favicon.href = url;
    }
    else {
      favicon.href = repo_favicon_link("favicon.ico");
    }
  };
  // handleFavIcon()

  const [isRedirect, /*setRedirect*/] = useState(false)

  //LOADER TIMEOUT
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.process = {
      ...window.process,
    };
  }, []);

  useEffect(() => {
    if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null) {
      set_language('pt')
    }

    // usarToken().saveToken({token: Hosts.SITES.SIMWEBSITE.ACCESS_TOKEN})
    setToken({ "token_site": Hosts.SITES.SIMWEBSITE.ACCESS_TOKEN })

    const timer = setTimeout(() => {
      setIsLoading(false);
      //setCount('Timeout called!');
    }, 500);

    return () => clearTimeout(timer);

    /*    setTimeout(() => {
        setIsLoading(false);
      }, 500);  */
  }, [setToken])

  useEffect(() => {
    
    (async () => {

        let temp_token_info = await usarToken().getToken()
        let token_info = JSON.parse(temp_token_info)

        if(token_info !== undefined && token_info !== null && token_info.user_info !== undefined) {
          // console.log('app.js token_info', token_info)
        }
        else {
          if(pathname !== '/') {
            // setRedirect(true)
          }
        }
    })()

  }, [pathname])

    useEffect(() => {
  
      set_dados(is_logged_in.current = false)

      const getConfig = async () => {

        if(is_logged_in.current) {
          await reqGET(`${Hosts.SIMCore_API}/web/structure/${Hosts.companycode}`)
              .then(res => {
                  if(res.data !== undefined && res.data.length > 0) {
                      res.data.forEach((v) => {
                          if (v.info.principal === true) {

                              if (lang !== 'pt') {
                                  let x = 0
                                  content_language.forEach((cl) => {
                                      if (cl.code === lang) {

                                          v.content.childs.forEach((el) => {
                                              if (el.id_content !== '') {
                                                  if (el.children !== undefined) {
                                                      x = x - el.children.length
                                                      el.children.forEach((el_c) => {
                                                          reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/${el_c.id_content}`)
                                                              .then(res_3 => {
                                                                  if (res_3.data.length > 0) {
                                                                      if (res_3.data[0].info.language.length > 0) {
                                                                          if (res_3.data[0].info.language[cl.id] !== undefined && res_3.data[0].info.language[cl.id] !== null) {
                                                                              if (res_3.data[0].info.language[cl.id]['name'] !== '') {
                                                                                  el_c.title = res_3.data[0].info.language[cl.id]['name'];

                                                                                  x++
                                                                                  if (v.content.childs.length === x) {
                                                                                      setRefresh(refresh => refresh + 1)
                                                                                  }
                                                                              }
                                                                          }
                                                                      }
                                                                      else {
                                                                          x++
                                                                          if (v.content.childs.length === x) {
                                                                              setRefresh(refresh => refresh + 1)
                                                                          }
                                                                      }
                                                                  }
                                                                  else {
                                                                      x++
                                                                      if (v.content.childs.length === x) {
                                                                          setRefresh(refresh => refresh + 1)
                                                                      }
                                                                  }
                                                              })
                                                      })
                                                  }

                                                  reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/${el.id_content}`)
                                                      .then(res_2 => {
                                                          if (res_2.data.length > 0) {
                                                              if (res_2.data[0].info.language.length > 0) {
                                                                  if (res_2.data[0].info.language[cl.id] !== undefined && res_2.data[0].info.language[cl.id] !== null) {
                                                                      if (res_2.data[0].info.language[cl.id]['name'] !== '') {
                                                                          el.title = res_2.data[0].info.language[cl.id]['name'];

                                                                          x++
                                                                          if (v.content.childs.length === x) {
                                                                              setRefresh(refresh => refresh + 1)
                                                                          }
                                                                      }
                                                                  }
                                                              }
                                                              else {
                                                                  x++
                                                                  if (v.content.childs.length === x) {
                                                                      setRefresh(refresh => refresh + 1)
                                                                  }
                                                              }
                                                          }
                                                          else {
                                                              x++
                                                              if (v.content.childs.length === x) {
                                                                  setRefresh(refresh => refresh + 1)
                                                              }
                                                          }
                                                      })


                                              }
                                              else {
                                                  if (el['language'] !== undefined && el['language'] !== null) {
                                                      if (el.language[cl.id] !== undefined && el.language[cl.id]['title'] !== undefined && el.language[cl.id]['title'] !== '') {
                                                          el.title = el.language[cl.id]['title']

                                                          x++
                                                          if (v.content.childs.length === x) {
                                                              setRefresh(refresh => refresh + 1)
                                                          }
                                                      }
                                                  }
                                              }

                                          })

                                      }
                                  })

                              }

                              set_dados(navbar.current = v);
                          }
                      });

                  }

              })
              .catch(erro => console.log('ERROR', erro))
        }

        await reqGET(`${Hosts.SIMCore_API}/web/content/slug/${Hosts.companycode}/customer`)
          .then(res => {
            
            if(res.data.length > 0) {
              set_template(res.data[0].info.template !== undefined && res.data[0].info.template.id !== undefined ? res.data[0].info.template : {info: {tag: ''}})
              set_theme(res.data[0].info.theme !== undefined && res.data[0].info.theme.id !== undefined ? res.data[0].info.theme : {info: {tag: ''}})
              set_maintenance(res.data[0].info.maintenance)

              res.data[0].info['template'] = { info: { tag: 'header-customer' } }
              res.data[0].info['header'] = { info: { tag: 'header-customer' } }
              res.data[0].info['footer'] = { info: { tag: 'footer-customer' } }

              set_dados_config(res.data[0])
  
              document.getElementById("head_style").innerHTML = ":root { --primary: " + res.data[0].info.theme.info.color.primary + " !important; --primary-rgb: " + res.data[0].info.theme.info.color.primary_rgb + " !important; --secondary: " + res.data[0].info.theme.info.color.secondary + " !important; }";
              document.title = translate(res.data[0].content[0].title, lang)
  
              if(res.data[0].content[0].favicon.url !== undefined && res.data[0].content[0].favicon.url !== '') {
                handleFavIcon(res.data[0].content[0].favicon.url)
              }
              else {
                handleFavIcon()
              }
  
            }
            else {
              set_template({info: {tag: ''}})
              set_theme({info: {tag: ''}})
              set_maintenance(true)
              set_dados_config({info: {maintenance: true}})
  
              handleFavIcon()
            }
  
          })
          .catch(erro => console.log('Erro', erro))

      }
      
      (async () => {

        let temp_token_info = await usarToken().getToken()
        let token_info = JSON.parse(temp_token_info)

        if(token_info !== undefined && token_info !== null) {
            set_dados(is_logged_in.current = true)
        }
        else {
            set_dados(is_logged_in.current = false)

            if(pathname !== '/' && !pathname.includes('/regist/')) {
              window.location.href = Hosts.EMAIL_WEB_SITE_URL + '/';
            }
        }

        await getConfig()
      })()
  
    }, [lang, pathname])

  return isRedirect ? 
      <Redirect to={'/'} replace />
    :
    isLoading ?
      <Loader />
    :
      <>
        <Cookies item={{template: template?.info?.tag, theme: theme?.info?.tag, dados_config: dados_config}} />
        <div className={'body-container ' + template?.info?.tag + ' ' + theme?.info?.tag}>
          <Switch>

            <Route path={"/"} render={(props) => <Pagina {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Pagina}*/ exact={true} />

            <Route path={"/pag/:pag_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />

            <Route path={"/article/:article_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/news/:article_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/press/:press_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/manual/:manual_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/catalog/:catalog_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/technical/:technical_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/document/:document_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/gallery/:gallery_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/partner/:partner_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/service/:service_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/product/:product_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/brand/:brand_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/menu/:menu_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />


            <Route path={"/information/pag/:pag_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/information/news/:article_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/information/press/:press_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/information/manual/:manual_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/information/catalog/:catalog_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/information/technical/:technical_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/information/glossario/:glossario_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/information/sectorial/:sectorial_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/information/document/:document_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/information/gallery/:gallery_id"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
            <Route path={"/information/:slug"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />


            <Route path={"/user/profile"} render={(props) => <PerfilClient {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Pagina}*/ exact={true} />
            <Route path={"/client/profile"} render={(props) => <PerfilClient2 {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Pagina}*/ exact={true} />
            
            <Route path={"/regist/user"} render={(props) => <RegistClient {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Pagina}*/ exact={true} />
            <Route path={"/regist/user/recovery/:hash"} render={(props) => <RecoveryClient {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Pagina}*/ exact={true} />


            <Route path={"/support/assistance"} render={(props) => <SupportAssistance {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Pagina}*/ exact={true} />
            <Route path={"/support/complaint"} render={(props) => <SupportComplaint {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Pagina}*/ exact={true} />
            <Route path={"/support/suggestion"} render={(props) => <SupportSuggestion {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Pagina}*/ exact={true} />
            <Route path={"/support/proposal"} render={(props) => <SupportProposal {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Pagina}*/ exact={true} />
            
            
            <Route path={"/relation/documents"} render={(props) => <RelationDocuments {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Pagina}*/ exact={true} />
            <Route path={"/relation/downloads"} render={(props) => <RelationDownloads {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Pagina}*/ exact={true} />
            
            <Route path={"/list/clients"} render={(props) => <ClientList {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Pagina}*/ exact={true} />
            <Route path={"/list/notifications"} render={(props) => <NotificationList {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Pagina}*/ exact={true} />


            <Route path={"/:slug"} render={(props) => <Content {...props} dados_config={dados_config} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />

            <Redirect to="/" replace />

          </Switch >
        </div>
        <GoTopButton item={{template: template?.info?.tag, theme: theme?.info?.tag}} />
      </>
}

export default App;

